import { makeAutoObservable } from "mobx";
import { UserProfile } from "./UserProfile";

export class User {
  public userProfile: UserProfile = new UserProfile({});

  constructor(public idToken: string, public currentSessionId: string, public username: string, public lastActivityTimeStamp: string) {
    makeAutoObservable(this);
  }

  public get fullName() {
    return `${this.userProfile.firstName} ${this.userProfile.lastName}`;
  }

  public get isProfileFilled() {
    return this.userProfile?.isProfileFilled;
  }

  public get isLoggedIn() {
    return this.idToken?.length > 0;
  }
}
